<div class="table-responsive-dtroy mt-1 bg-primary" >
  <table class="table align-middle table-bordered table-sm m-0" style="background-color: #5D6B99 !important;">
    <thead>
    <tr>
      <th id="colMov" style="display: none;" class=" movementOrderName">
        <span>Editar</span>
      </th>
      <th class="priorityNameCell">
        <span>Prioridad</span>
      </th>
      <th class="indicatorNameCell text-center ">
        <span>Indicador</span>
      </th>
      <th class="currencyCell ">
        <span>Meta</span>
      </th>
      <th class="currencyCell ">
        <span>Resultado</span>
      </th>
    </tr>
    </thead>
    <tbody>
    <tr>
      <td colspan="4">
        <div *ngFor="let departments of indicators; let departmentIndex = index" id="all" cdkDropList (cdkDropListDropped)="dropDep($event,departments[0][0].departmentName,departmentIndex)" >
          <div>
            <div class="box-move" *ngFor="let areas of departments; let areaIndex = index" [cdkDragData]="indicator" cdkDrag>
              <div class="placeholder" *cdkDragPlaceholder></div>
              <tr class="areaRow">
                <td class="movementOrder movementOrderName d-none">
                  <div class="handle" cdkDragHandle >
                    <svg width="35px" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
                      <path d="M0 0h24v24H0z" fill="none"></path>
                    </svg>
                  </div>
                </td>

              </tr>
              <div id="all" cdkDropList class="list-container" (cdkDropListDropped)="drop($event,areas[0].areaName)">
                <div class="box-move" *ngFor="let indicator of areas; let indicatorIndex = index" [cdkDragData]="indicator" cdkDrag>
                  <ng-container *ngIf="indicatorIndex < 5 && departmentIndex == 0 && areaIndex == 0">
                    <ng-container *ngIf="indicator.priority === 'AAA'">
                      <div class="placeholder" *cdkDragPlaceholder></div>
                      <tr id="{{!mesurements[indicator.id!] ? 'dangerRow' : ''}}"
                          (dblclick)="addMesurement(indicator, togglePeriod ? 'weekly' : 'monthly')" colspan="8">

                        <td class="movementOrder movementOrderName d-none" style="background-color: #F4F4F4 !important;">
                          <div class="handle" cdkDragHandle>
                            <svg width="28px" fill="currentColor" viewBox="0 0 28 28">
                              <path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
                              <path d="M0 0h24v24H0z" fill="none"></path>
                            </svg>
                          </div>
                        </td>
                        <td class="priorityNameCell" style="background-color: #F4F4F4 !important;">
                          <div class="d-flex w-100 justify-content-center align-content-center">
                                                    <span style="width: 50px;" class="badge {{getClassBadgePriority(indicator.priority!)}}">
                                                        {{indicator.priority}}
                                                    </span>
                          </div>
                        </td>
                        <td class="indicatorNameCell" style="background-color: #F4F4F4 !important;">
                                                <span>
                                                    {{indicator.indicator}}
                                                </span>
                        </td>
                        <td class="currencyCell" style="background-color: #F4F4F4 !important;">
                                                <span class="numberCell">
                                                    {{returnChangedFormat(indicator.type!, indicator.monthgoal[monthName]!)}}
                                                </span>
                        </td>
                        <td class="currencyCell {{ getClassCell(indicator) }}">
                                                <span class=" numberCell">
                                                    {{returnChangedFormat(indicator.type!, mesurements[indicator.id!] ?
                                                  mesurements[indicator.id!].result :
                                                  0)}}
                                                </span>
                        </td>
                      </tr>
                    </ng-container>
                  </ng-container>

                </div>
              </div>
            </div>
          </div>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
</div>


<input style="display: none;" type="file"  #fileCause (change)="uploadFileCause($event.target)">

<input style="display: none;" type="file"  #filePlan (change)="uploadFilePlan($event.target)">

<ngx-spinner></ngx-spinner>

<style>
  .table {
    border-collapse: collapse;
    width: 100%;
    background-color: #5D6B99;
  }

  .table-responsive-dtroy {
    max-height: 400px; /* Establece una altura máxima para la tabla */
    overflow-y: auto; /* Habilita la barra de desplazamiento vertical si el contenido excede la altura máxima */
  }

  /* Estilos adicionales para asegurar que el encabezado de la tabla se mantenga fijo */
  .table-fixed-header {
    width: 100%;
    table-layout: fixed;
  }

  .thFixed {
    position: sticky;
    top: 0;
    background-color: white;
    z-index: 10;
  }

  /* Estilos para las celdas */
  .priorityNameCell, .currencyCell {
    width: 25%;
    text-align: center;
    vertical-align: middle;
  }

  .indicatorNameCell {
    width: 50%;
    text-align: left;
    vertical-align: middle;
  }

  .numberCell {
    text-align: right;
    padding-right: 1rem;
  }

  .badge {
    display: inline-block;
    padding: 0.35em 0.65em;
    font-size: 75%;
    font-weight: 700;
    line-height: 1;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: 0.25rem;
  }
  th{
    background-color: #5D6B99 !important;
    color: #FFFFFF;
    font-size: large;
  }



</style>
